export default "__VITE_ASSET__CJ8lJEB7__"